<div class="sbid">
  <header class="sbid-head">
    <div>
      <h2 mat-dialog-title class="sbid-title">Send for bidding</h2>
      <p class="sbid-sub">Invite consultancies to bid on this BOQ. They get a link to view details and submit.</p>
    </div>
    <button type="button" class="sbid-close" (click)="onCancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="sbid-form">
    <div class="sbid-body">
      <section class="sbid-summary">
        <div class="sbid-summary-item">
          <span class="sbid-k">Project</span>
          <span class="sbid-v">{{ data.project_name }}</span>
        </div>
        <div class="sbid-summary-item">
          <span class="sbid-k">BOQ</span>
          <span class="sbid-v">{{ data.boq_code }}</span>
        </div>
      </section>

      <section class="sbid-fees" *ngIf="feesLoading || fees">
        <p *ngIf="feesLoading" class="sbid-hint">Calculating participation fee…</p>
        <ng-container *ngIf="fees && !feesLoading">
          <div class="sbid-fee">
            <span class="sbid-k">BOQ total</span>
            <span class="sbid-v">{{ formatMoney(fees.boq_total) }}</span>
          </div>
          <div class="sbid-fee">
            <span class="sbid-k">Rate</span>
            <span class="sbid-v">{{ fees.rate_pct }}%</span>
          </div>
          <div class="sbid-fee sbid-fee--accent">
            <span class="sbid-k">Bid fee</span>
            <span class="sbid-v">{{ formatMoney(fees.bid_fee) }}</span>
          </div>
        </ng-container>
        <p class="sbid-hint sbid-fees-note">Display only — not collected in this step.</p>
      </section>

      <section class="sbid-invite">
        <div class="sbid-invite-head">
          <h3>Who to invite</h3>
          <span class="sbid-count" *ngIf="inviteCount">{{ inviteCount }} selected</span>
        </div>
        <div class="sbid-invite-grid">
          <label class="sbid-field">
            <span class="sbid-label">Registered consultancies</span>
            <ng-select
              formControlName="invited_org_ids"
              [items]="consultancyOrgs"
              bindLabel="org_name"
              bindValue="org_id"
              placeholder="Search organizations"
              [multiple]="true"
              [loading]="loading"
              [searchable]="true"
              [closeOnSelect]="false"
              appendTo="body">
            </ng-select>
          </label>
          <label class="sbid-field">
            <span class="sbid-label">Or email (not registered)</span>
            <ng-select
              formControlName="invited_emails"
              [items]="[]"
              [addTag]="true"
              [addTagText]="'Add email'"
              placeholder="Type email, press Enter"
              [multiple]="true"
              [searchable]="true"
              [closeOnSelect]="false"
              appendTo="body">
            </ng-select>
          </label>
        </div>
        <p class="sbid-error" *ngIf="!hasAnyInvite() && form.get('invited_org_ids')?.touched">
          Select at least one organization or add an email.
        </p>
      </section>

      <section class="sbid-meta">
        <label class="sbid-field">
          <span class="sbid-label">Bid closes</span>
          <input
            class="sbid-input"
            type="datetime-local"
            formControlName="bid_closing_at"
            [min]="minBidClosingDate">
          <span class="sbid-hint">Bidders cannot submit after this time. Default is 30 days from now.</span>
        </label>
      </section>

      <section class="sbid-notes">
        <span class="sbid-label">Requirements / instructions <span class="sbid-optional">optional</span></span>
        <div class="editor-wrapper">
          <angular-editor
            formControlName="requirements"
            [config]="editorConfig"
            id="send-bidding-requirements-editor">
          </angular-editor>
        </div>
      </section>
    </div>

    <footer class="sbid-actions">
      <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="submitting || !hasAnyInvite()">
        {{ submitting ? 'Sending…' : (inviteCount ? 'Send to ' + inviteCount + ' recipient' + (inviteCount === 1 ? '' : 's') : 'Send for bidding') }}
      </button>
    </footer>
  </form>
</div>
